import sicknesscategory from '@/modules/apies/public/sicknesscategory.js'
import authentication from '@/modules/apies/authentication'
import foodmeal from '@/modules/apies/food/foodmeal'
import foodcategory from '@/modules/apies/food/foodcategory'
import foodunit from '@/modules/apies/food/foodunit'
import food from '@/modules/apies/food/food'
import foodrecipes from '@/modules/apies/food/foodrecipes'
import foodrecipescomment from '@/modules/apies/food/foodrecipescomment'
import country from '@/modules/apies/public/country'
import state from '@/modules/apies/public/state'
import sickness from '@/modules/apies/public/sickness'
import foodindicator from '@/modules/apies/food/foodindicator'
import foodsuggestion from '@/modules/apies/food/foodsuggestion'
import foodlist from '@/modules/apies/food/foodlist'
import foodcomment from '@/modules/apies/food/foodcomment'
import user from '@/modules/apies/user/user'
import userrole from '@/modules/apies/user/userrole'
import userpermission from '@/modules/apies/user/userpermission'
import content from '@/modules/apies/public/content'
import version from '@/modules/apies/public/version'
import diet from '@/modules/apies/diet/diet'
import dietduration from '@/modules/apies/diet/dietduration'
import dietdurationprice from '@/modules/apies/diet/dietdurationprice'
import activity from '@/modules/apies/activity/activity'
import activitycomment from '@/modules/apies/activity/activitycomment'
import activitypackagecomment from '@/modules/apies/activity/activitypackagecomment'
import activitycategory from '@/modules/apies/activity/activitycategory'
import activitypackage from '@/modules/apies/activity/activitypackage'
import activitypackagecourse from '@/modules/apies/activity/activitypackagecourse'
import activitygroup from '@/modules/apies/activity/activitygroup'
import city from '@/modules/apies/public/city'
import shorturl from '@/modules/apies/public/shorturl'
import discount from '@/modules/apies/order/discount'
import userdietorder from '@/modules/apies/order/userdietorder'
import activitypackageorder from '@/modules/apies/order/activitypackageorder'
import faq from '@/modules/apies/public/faq'
import faqcategory from '@/modules/apies/public/faqcategory'
import opinion from '@/modules/apies/public/opinion'
import ticketdepartment from '@/modules/apies/ticket/ticketdepartment'
import ticket from '@/modules/apies/ticket/ticket'
import UserSickness from '@/modules/apies/user/userSickness'
import userPlanFood from '@/modules/apies/user/userPlanFood'
import userDietTerms from '@/modules/apies/user/userDietTerms'
import muscle from '@/modules/apies/activity/muscle'
import banner from '@/modules/apies/banner/banner'
import bannerposition from '@/modules/apies/banner/bannerposition'
import report from '@/modules/apies/report/report'
import blog from '@/modules/apies/blog/blog'
import project from '@/modules/apies/project/project'
import blogcategory from '@/modules/apies/blog/blogcategory'
import projectcategory from '@/modules/apies/project/projectcategory'
import blogcomment from '@/modules/apies/blog/blogcomment'
import segmentBasic from '@/modules/apies/segment/segmentBasic'
import segmentCustom from '@/modules/apies/segment/segmentCustom'
import declarations from '@/modules/apies/segment/decleration'
import calorie from '@/modules/apies/dedicatedDiet/calorie'
import supplement from '@/modules/apies/dedicatedDiet/supplement'
import recommend from '@/modules/apies/dedicatedDiet/recommend'
import recommendcategory from '@/modules/apies/dedicatedDiet/recommendcategory'
import dedicatedfoodList from '@/modules/apies/dedicatedDiet/foodList'
import dedicatedDietList from '@/modules/apies/dedicatedDiet/dedicatedDietList'
import errorlog from '@/modules/apies/errorLog/errorLog'
import question from '@/modules/apies/question/question'
import userspecialdiet from "@/modules/apies/user/userspecialdiet"
import userQuestionAnswer from "@/modules/apies/user/userQuestionAnswer"
import userQuestionAnswerSheet from "@/modules/apies/user/userQuestionAnswerSheet"
import usertoken from "@/modules/apies/user/usertoken"
import product from '@/modules/apies/product/product'
import productcategory from '@/modules/apies/product/productcategory'

export default {
  authentication,
  foodmeal,
  foodcategory,
  foodunit,
  food,
  country,
  state,
  sickness,
  foodindicator,
  foodsuggestion,
  foodlist,
  user,
  userrole,
  userpermission,
  content,
  version,
  diet,
  activity,
  activitycategory,
  city,
  dietduration,
  dietdurationprice,
  discount,
  userdietorder,
  foodcomment,
  faq,
  faqcategory,
  ticketdepartment,
  ticket,
  UserSickness,
  userPlanFood,
  userDietTerms,
  muscle,
  activitypackage,
  activitypackagecourse,
  banner,
  bannerposition,
  report,
  activitygroup,
  activitypackageorder,
  blog,
  blogcomment,
  blogcategory,
  sicknesscategory,
  segmentBasic,
  segmentCustom,
  declarations,
  errorlog,
  calorie,
  supplement,
  recommend,
  recommendcategory,
  dedicatedfoodList,
  dedicatedDietList,
  question,
  shorturl,
  foodrecipes,
  activitycomment,
  activitypackagecomment,
  foodrecipescomment,
  userspecialdiet,
  userQuestionAnswer,
  userQuestionAnswerSheet,
  usertoken,
  projectcategory,
  project,
  opinion,
  product,
  productcategory
}
